export const studentLoansQuestions = {
  studentLoans: {
    header: 'applicationForm.STUDENT_LOANS.note',
    empty: 'applicationForm.STUDENT_LOANS.noLoans',
    add: 'applicationForm.STUDENT_LOANS.addLoan',
  },
};
